export const DEFAULT_IMAGE_MAX_FILE_SIZE_MB = 10;

type ImageType = {
	extension: string;
	mimeType: string;
};

const ACCEPTED_TYPES: ImageType[] = [
	{
		extension: "jpg",
		mimeType: "image/jpg",
	},
	{
		extension: "jpeg",
		mimeType: "image/jpeg",
	},
	{
		extension: "png",
		mimeType: "image/png",
	},
	{
		extension: "webp",
		mimeType: "image/webp",
	},
];

export const ACCEPTED_IMAGE_MIME_TYPES = new Set(
	ACCEPTED_TYPES.map((type) => type.mimeType)
);

export const ACCEPTED_IMAGE_EXTENSIONS = new Set(
	ACCEPTED_TYPES.map((type) => type.extension)
);

export const ACCEPTED_IMAGE_EXTENSIONS_LIST = Array.from(
	ACCEPTED_IMAGE_EXTENSIONS
).join(", ");

type ValidationResult =
	| { valid: true; error?: undefined }
	| { valid: false; error: string };

export const validateImageFile = (
	file: File,
	fileSizeMB: number | null = null
): ValidationResult => {
	if (!ACCEPTED_IMAGE_MIME_TYPES.has(file.type)) {
		return {
			valid: false,
			error: `Only ${Array.from(ACCEPTED_IMAGE_EXTENSIONS)
				.join(", ")
				.replace(/,([^,]*)$/, " and$1")} files are accepted.`,
		};
	}

	// Keep the limit in MB for the message and in bytes for the comparison. Reusing
	// the byte value in the message is what produced "less than 10485760MB."
	const limitMB = fileSizeMB ? fileSizeMB : DEFAULT_IMAGE_MAX_FILE_SIZE_MB;
	const sizeCheck = limitMB * 1024 * 1024;

	if (file.size > sizeCheck) {
		return {
			valid: false,
			error: `File size must be less than ${limitMB}MB.`,
		};
	}
	return { valid: true };
};
